'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YearForm = function (_React$Component) {
	_inherits(YearForm, _React$Component);

	function YearForm(props) {
		_classCallCheck(this, YearForm);

		var _this = _possibleConstructorReturn(this, (YearForm.__proto__ || Object.getPrototypeOf(YearForm)).call(this, props));

		_this.onNameChange = _this.onNameChange.bind(_this);
		_this.cancel = _this.cancel.bind(_this);
		_this.onClickSubmit = _this.onClickSubmit.bind(_this);
		return _this;
	}

	_createClass(YearForm, [{
		key: 'componentWillMount',
		value: function componentWillMount() {

			var initialState = {
				nameErrorMsg: '',
				yearErrorMsg: ''
			};

			if (typeof this.props.year !== 'undefined') {
				initialState.year = this.props.year;
			} else {
				initialState.year = {
					name: ''
				};
			}

			this.setState(initialState);
		}
	}, {
		key: 'onClickSubmit',
		value: function onClickSubmit() {
			this.props.submit(this.state.year);
		}
	}, {
		key: 'onNameChange',
		value: function onNameChange(event, value) {
			this.setState({
				year: _extends({}, this.state.year, {
					name: value
				})
			});
		}
	}, {
		key: 'cancel',
		value: function cancel() {
			this.props.cancel();
		}
	}, {
		key: 'render',
		value: function render() {
			var requestingCreateYear = this.props.requestingCreateYear;
			var _state = this.state,
			    year = _state.year,
			    nameErrorMsg = _state.nameErrorMsg;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_TextField2.default, {
						hintText: 'Nome',
						floatingLabelText: 'Nome',
						floatingLabelFixed: true,
						onChange: this.onNameChange,
						value: year.name,
						errorText: nameErrorMsg,
						fullWidth: true
					})
				),
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_RaisedButton2.default, { label: 'Cancelar', onClick: this.cancel }),
					_react2.default.createElement(_RaisedButton2.default, {
						primary: true, label: 'Enviar',
						onClick: this.onClickSubmit,
						style: { marginLeft: '1rem' }
					}),
					requestingCreateYear && _react2.default.createElement(_CircularProgress2.default, null)
				)
			);
		}
	}]);

	return YearForm;
}(_react2.default.Component);

exports.default = YearForm;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/years/YearForm.js
// module id = 1312
// module chunks = 0